/* eslint-disable hum/restrict-constants-imports */
import {
    BalanceSheetCategory,
    OtherCategory,
} from "@/entities/DataAssociation/Account.model";
import { ACCOUNT_LIST } from "./labeling.constants";
import { StatementType } from "@/entities/DataAssociation/File.model";

export const balanceSheetAccounts = Object.values(ACCOUNT_LIST).filter(
    (account) =>
        account.statementType === StatementType.BALANCE_SHEET ||
        account.statementType === StatementType.MIXED,
);
export const balanceSheetAccountsByCategory = {
    [BalanceSheetCategory.ASSETS]: balanceSheetAccounts.filter(
        (account) => account.category === BalanceSheetCategory.ASSETS,
    ),
    [BalanceSheetCategory.LIABILITIES]: balanceSheetAccounts.filter(
        (account) => account.category === BalanceSheetCategory.LIABILITIES,
    ),
    [BalanceSheetCategory.EQUITY]: balanceSheetAccounts.filter(
        (account) => account.category === BalanceSheetCategory.EQUITY,
    ),
    [OtherCategory.REPORTED]: balanceSheetAccounts.filter(
        (account) => account.category === OtherCategory.REPORTED,
    ),
    [OtherCategory.EXCLUDED]: balanceSheetAccounts.filter(
        (account) => account.category === OtherCategory.EXCLUDED,
    ),
};
